import { createRoute } from '@tanstack/react-router';

import NotFoundView from 'features/not-found/NotFoundView';
import { merchantVerifiedRoute } from 'root/routeTree';

import MenuLayout from './MenuLayout';

export const menuLayoutRoute = createRoute({
  getParentRoute: () => merchantVerifiedRoute,
  component: MenuLayout,
  id: 'menuLayout',
  notFoundComponent: NotFoundView,
});
